/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const DELETE_ROLE_TITLE = 'Are you sure you want to delete the role ';
export const DIALOGUE_OK = 'Delete Role';
export const DIALOGUE_CANCEL = 'Cancel';
export const DIALOGUE_CONTENT = 'Delete Role?';
export const DELETE_GLOBAL_ROLE = 'Delete Global Role';
export const DIALOGUE_CONTENT_GLOBAL_ROLE = 'Are you sure you want to delete the global role ';

export const SNACKBAR_ALERT_DEFAULT_PROPS = {
    showSnackbar: true,
    autoHideDuration: 5000,
    message: '',
    severity: 'success' as 'success' | 'error'
};

export const DELETE_ROLE_SUCCESS = 'Role {0} has been deleted successfully';
export const DELETE_ROLE_ERROR_422 = 'Unable to delete the Role because it is assigned to User(s)';
export const DELETE_ROLE_ERROR = 'Error in deleting role: {0}';
export const TITLE = 'accessing Roles';
export const SEARCH_ROLE = 'Search Roles (Min. 3 chars)';
export const GLOBAL_ROLE_TYPE = 'global';
